import {
  READABLE_TURN_AROUND,
  TURN_AROUND_CALCULATIONS,
} from "../api/Blueprints";

export function slaDisplay(
  turnAround: string | undefined,
  slaHours: number
): string {
  if (turnAround === TURN_AROUND_CALCULATIONS.Hour) {
    return `${slaHours} hours`;
  }
  if (turnAround === TURN_AROUND_CALCULATIONS.Days) {
    return READABLE_TURN_AROUND.Days;
  }
  if (turnAround === TURN_AROUND_CALCULATIONS.SingleBusinessDay) {
    return READABLE_TURN_AROUND.SingleBusinessDay;
  }
  if (turnAround === TURN_AROUND_CALCULATIONS.ThreeSixty) {
    return READABLE_TURN_AROUND.ThreeSixty;
  }
  return "Unknown";
}
